import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { createBasket } from './utils';

export default function* listenCreateBasket() {
  yield takeEvery(basketActions.createBasket.toString(), createBasket);
}
